"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutObjectAclInput_1 = require("./PutObjectAclInput");
var PutObjectAclOutput_1 = require("./PutObjectAclOutput");
var NoSuchKey_1 = require("./NoSuchKey");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutObjectAcl = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutObjectAcl",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}?acl"
    },
    input: {
        shape: PutObjectAclInput_1.PutObjectAclInput
    },
    output: {
        shape: PutObjectAclOutput_1.PutObjectAclOutput
    },
    errors: [
        {
            shape: NoSuchKey_1.NoSuchKey
        }
    ]
};
//# sourceMappingURL=PutObjectAcl.js.map